import Helper from "../d3-common"

export function getDimensions(elementId) {

    // Brush
    const histogramHeight = 50 // Brush
    const  histogramMargin = 20
    const textMargin = 75 // for labels

    const dim = Helper.getMaxDimensions(elementId)
    const vizWitdh = dim.max - 2*histogramHeight - histogramMargin - textMargin
    const vizHeigth = dim.max - 2*histogramHeight - histogramMargin - textMargin

    const dimensions = {
        maxWidth: dim.w,
        width: vizWitdh + textMargin*2,
        height: vizHeigth + histogramHeight + histogramMargin + textMargin*2,
        margin: textMargin, 
        arcThickness: 15,
    }
    dimensions.arcRadius = (vizWitdh - dimensions.margin)/2
    dimensions.arcInnerRadius = dimensions.arcRadius - dimensions.arcThickness
    dimensions.ribbonRadius = dimensions.arcInnerRadius - dimensions.arcThickness + 10
    dimensions.textRadius = dimensions.arcRadius + dimensions.arcThickness

    dimensions.boundedWidth = vizWitdh - dimensions.margin - dimensions.margin
    dimensions.boundedHeight = vizHeigth - dimensions.margin - dimensions.margin

    dimensions.histogramHeight = histogramHeight
    dimensions.histogramMargin = histogramMargin
    dimensions.histogram = histogramHeight + histogramMargin
    dimensions.histogramWidth = histogramHeight

    dimensions.brushWidth = dimensions.arcRadius * 2
    if (dimensions.brushWidth > 600){
        dimensions.brushWidth = 600
    }

    return dimensions
}

export function getColors() {
    const colors = {
        arc: "#1fdbc8",
        arcOpacity: 0.4,
        slider: "#1fdbc8",
        sliderOpacity: 0.6,
        ribbon: "#a66a16",
        ribbonOpacity: 0.2,
        border: "#ccc",
        grey: "#bec4c3",
    }

    return colors
}
export default getDimensions
